import { navImgAccess, navImgBeacon, navImgCamera, navImgIOT, navImgOS, navImgRTLS, navImgSensor, navImgWorld } from '@assets/images/nav';

export default {
  product: [
    {
      icon: navImgRTLS,
      title: 'ORBRO OS',
      link: '/vi/os',
      path: [
        { text: 'ORBRO Server', link: '/vi/os/server' },
        { text: 'ORBRO Edge RTLS', link: '/vi/os/rtls' },
        { text: 'ORBRO Edge AI', link: '/vi/os/ai' },
        { text: 'L2 Switch', link: '/vi/os/switch' },
      ],
    },
    {
      icon: navImgBeacon,
      title: 'Định vị trong nhà',
      link: '/vi/rtls',
      path: [
        { text: 'TwinTracker BLE', link: '/vi/rtls/ble' },
        { text: 'TwinTracker AoA', link: '/vi/rtls/aoa' },
        { text: 'TwinTracker UWB', link: '/vi/rtls/uwb' },
        { text: 'Comfort Kit', link: '/vi/rtls/comfort' },
      ],
    },
    {
      icon: navImgAccess,
      title: 'Định vị bằng hình ảnh',
      link: '/vi/camera',
      path: [
        { text: 'AI Edge', link: '/vi/camera/edge' },
        { text: 'AI Server', link: '/vi/camera/server' },
      ],
    },
    {
      icon: navImgAccess,
      title: 'Định vị ngoài trời',
      link: 'none',
      path: [
        { text: 'Thiết bị GPS', link: '/vi/outdoor/gps' },
        { text: 'Thẻ GPS (LoRA)', link: '/vi/outdoor/lora' },
      ],
    },
    {
      icon: navImgSensor,
      title: 'Hệ thống ra vào',
      link: '/vi/access',
      path: [
        { text: 'Access Auto', link: '/vi/access/auto' },
        { text: 'Access Lite', link: '/vi/access/pro' },
        { text: 'Phụ kiện vào', link: '/vi/access/accessory' },
      ],
    },
    {
      icon: navImgSensor,
      title: 'IIoT (Internet Vạn Vật Công Nghiệp)',
      link: '/vi/iot',
      path: [
        { text: 'Cảm biến LoRA', link: '/vi/iot/LoRASensor' },
        { text: 'Máy đo CO₂', link: '/vi/iot/co2' },
        { text: 'Thiết bị đo chất lượng không khí', link: '/vi/iot/air' },
        { text: 'Chuông báo khẩn cấp', link: '/vi/iot/bell' },
      ],
    },
    {
      icon: navImgWorld,
      title: 'Hệ thống tích hợp',
      link: '/vi/integration',
      path: [{ text: 'Hệ thống Robot', link: '/vi/integration/robot' }],
    },
  ],

  OS: {
    icon: navImgOS,
    title: 'ORBRO OS',
    desc: 'Từ hệ thống ra vào, định vị thời gian thực đến điều khiển IoT, ORBRO OS là dịch vụ hợp nhất mọi công nghệ thông minh để quản lý không gian hiệu quả. Trải nghiệm tương lai thông minh ngay hôm nay.',
    more: 'Tìm hiểu thêm',
    link: '/vi/os',
  },

  solution: [
    {
      title: 'Xây dựng',
      path: [
        {
          text: 'Quản lý an toàn công nhân',
          link: '/enterprise/construction/safety',
        },
        {
          text: 'Quản lý vật liệu xây dựng',
          link: '/enterprise/construction/asset',
        },
        {
          text: 'Quản lý thiết bị hạng nặng',
          link: '/enterprise/construction/equipment',
        },
        {
          text: 'Quản lý an toàn SOP',
          link: '/enterprise/construction/sop',
        },
      ],
    },
    {
      title: 'Y tế',
      path: [
        {
          text: 'Theo dõi vị trí bệnh nhân',
          link: '/enterprise/medical/patient',
        },
        {
          text: 'Quản lý chất thải y tế & tài sản',
          link: '/enterprise/medical/waste',
        },
      ],
    },
    {
      title: 'Thành phố',
      path: [
        {
          text: 'Hệ thống điều khiển giao thông AI',
          link: '/enterprise/city/traffic',
        },
        {
          text: 'An toàn thảm họa với Digital Twin',
          link: '/enterprise/city/digitaltwin',
        },
        {
          text: 'Hệ thống theo dõi chất thải phóng xạ',
          link: '/enterprise/city/energy',
        },
      ],
    },
    {
      title: 'Sản xuất',
      path: [
        {
          text: 'Quản lý quy trình thời gian thực',
          link: '/enterprise/manufacturing/process',
        },
        {
          text: 'Quản lý tồn kho thời gian thực',
          link: '/enterprise/manufacturing/asset',
        },
      ],
    },
    {
      title: 'Logistics',
      path: [
        {
          text: 'Quản lý tồn kho logistics',
          link: '/enterprise/logistics/asset',
        },
        {
          text: 'Theo dõi vị trí cửa sổ',
          link: '/enterprise/logistics/manage',
        },
        // {
        //   text: 'Quản lý an toàn công nhân kho',
        //   link: '/enterprise/logistics/safety',
        // },
      ],
    },
    {
      title: 'Văn phòng',
      path: [
        {
          text: 'Quản lý tài sản văn phòng',
          link: '/enterprise/office/asset',
        },
      ],
    },
    {
      title: 'Bán lẻ',
      path: [
        {
          text: 'Quản lý & phân tích khách tham quan',
          link: '/enterprise/retail/exhibition',
        },
      ],
    },
  ],

  support: [
    {
      title: 'Hỗ trợ khách hàng',
      path: [
        { text: 'Giới thiệu công ty', link: '/vi/company' },
        { text: 'Liên hệ kinh doanh', link: '/vi/request' },
        { text: 'Liên hệ đại lý', link: '/vi/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: 'Công nghệ',
      path: [
        { text: 'UWB', link: '/vi/enterprise/technology/uwb' },
        { text: 'BLE', link: '/vi/enterprise/technology/ble' },
        { text: 'Stereo Vision', link: '/vi/enterprise/technology/stereo-vision' },
        { text: 'Monocular Vision', link: '/vi/enterprise/technology/monocular-vision' },
        { text: 'TDoA', link: '/vi/enterprise/technology/tdoa' },
        { text: 'TWR', link: '/vi/enterprise/technology/twr' },
        { text: 'Địa giới ảo (Geofence)', link: '/vi/enterprise/technology/what-is-geofence' },
        { text: 'Digital Twin là gì', link: '/vi/enterprise/technology/what-is-digital-twin' },
      ],
    },
    {
      title: 'Phần mềm',
      link: 'new',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'Orbro World', link: 'https://home.orbro.io' },
        { text: 'Ghi chú phát hành', link: '/release-note' },
      ],
    },
    {
      title: 'Mạng xã hội',
      link: 'new',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver', link: 'https://blog.naver.com/orbro_platform' },
        { text: 'Medium', link: 'https://medium.com/@orbro' },
      ],
    },
  ],

  footerSupport: [
    {
      title: 'Hỗ trợ',
      path: [
        { text: 'Blog', link: '/vi/blog' },
        { text: 'Liên hệ kinh doanh', link: '/vi/request' },
        { text: 'Liên hệ báo giá', link: '/vi/pricing/1' },
        { text: 'Liên hệ đại lý', link: '/vi/partnership' },
        { text: 'ORBRO OS Guide', link: 'https://or-orbro-guide.gitbook.io/orbro-guide' },
      ],
    },
    {
      title: 'Tải xuống',
      path: [
        { text: 'iOS', link: 'https://apps.apple.com/us/app/orbro-service/id1673356996' },
        { text: 'Android', link: 'https://play.google.com/store/apps/details?id=com.orbro.mobile' },
        { text: 'Orbro World', link: 'https://home.orbro.io' },
        { text: 'Ghi chú phát hành', link: '/release-note' },
      ],
    },
    {
      title: 'Mạng xã hội',
      path: [
        { text: 'LinkedIn', link: 'https://kr.linkedin.com/company/kongtech' },
        { text: 'Naver Blog', link: 'https://blog.naver.com/orbro_platform' },
      ],
    },
  ],
};
